import React, { Component } from 'react';
import Cookies from "universal-cookie";
import {InputMask} from 'primereact/inputmask';
import { Message } from 'semantic-ui-react'

 import {Host} from '../../../config/config'

class DepartmentIpSearch extends Component {

  constructor(props){
    super(props)
    this.ipsearch=this.ipsearch.bind(this)
    this.fetcher=this.fetcher.bind(this)

    this.state  = {
      isFetching:true,
      cookies :  new Cookies(),
      nullsearchresult: false
    }
  }


fetcher(ip){

    fetch('http://'+Host+'/api/ocnitcustomerinfo/',

          {
        method: 'POST',
        headers: new Headers({
                 'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
        }),

        body: "com=ipsearch&section=ipsearch&ip="+ip+"&author="+this.state.cookies.get('sidd')+"&mode=get_nets_list" // <-- Post parameters
        // body: "com=ipsearch&section=ipsearch"

          }    )

          .then((response)=>response.json())

            .then((cname)=>{
                    console.log('asd'+cname.length);
                            if(cname.length > 0){
                                this.props.callback(cname[0].name)
                                this.setState({nullsearchresult:false})
                            }
                            else{
                              this.setState({nullsearchresult:true})
                              this.props.callback('')
                            }

                          })

}

componentDidMount(){
  //
}


ipsearch(e){
      console.log('ip '+this.ip.value)
      this.fetcher(this.ip.value)
}


  render() {

    return (
      <div className='depipsearch'>
            <div>
                или найти по ip:&nbsp;
                    <input type='text' ref={(ip) => { this.ip = ip }} placeholder="XXX.XXX.XXX.XXX"></input>

                    <a href={null} onClick={this.ipsearch} className='pointer'>  Искать </a>

                  {this.state.nullsearchresult ?  <Message negative>
                  <Message.Header>А адресном плане нет данных по этому ip адресу</Message.Header>
                  </Message>
                  :
                  null
                }


          </div>

      </div>
    );
  }

}
export default DepartmentIpSearch;
